import { DemographicModel } from 'api/dto/Demographic.dto';
import { Employee } from 'model/Employee';
import { PaginationModel } from 'model/Pagination.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'pulseLifecycle';

export namespace PulseLifecycleState {
  export type Domain = {
    list: Employee[];
    listPagination: PaginationModel | null;
    demographicsResource: Resource<DemographicModel[]>;
  };

  export const INITIAL_DOMAIN: Domain = {
    list: [],
    listPagination: null,
    demographicsResource: Resource.createPendingResource(),
  };
}
